import * as NavConstants from 'constants/NavConstants';
import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {Optional} from 'util/Types';

import type {ChatDraftState} from '../ChatDraftState';
import type {InitialUI} from './AISidepanelV2GlobalClientState';

function getClientStateModule(): {
  openExistingChat: (chatSessionId: string) => void;
  openDraftChat: (
    draftState: ChatDraftState,
    options: {initialUI?: Optional<InitialUI>; hideHistory?: boolean}
  ) => void;
} {
  // This avoids a circular dependency in react-render.bundle.js.
  return require('./AISidepanelV2GlobalClientState');
}

export function openChat(chatSessionId: string): void {
  // This avoids a circular dependency in react-render.bundle.js.
  const SidepanelActions = require('nav/sidepanel/SidepanelActions');
  getClientStateModule().openExistingChat(chatSessionId);
  SidepanelActions.expandSection(NavConstants.SECTIONS.AI);
}

export function openDraftChat(
  draftState: ChatDraftState,
  options: {initialUI?: Optional<InitialUI>} = {}
): void {
  getClientStateModule().openDraftChat(draftState, options);
}

/**
 * Opens a new draft chat in the AI sidepanel, fully expanded unless `expanded` is false, in which case it
 * opens semi-expanded alongside the current page (including a full-screen page), even if the sidepanel
 * was already fully expanded.
 */
export function openDraftChatInSidepanel(
  agentType: AgentType,
  initialPrompt: string = '',
  contextIds?: Array<string>,
  originSearchQuery?: string,
  {expanded = true}: {expanded?: boolean} = {}
): void {
  const {makeNewDraftState} = require('../ChatDraftState');
  const SidepanelActions = require('nav/sidepanel/SidepanelActions');
  getClientStateModule().openDraftChat(
    makeNewDraftState(agentType, initialPrompt, {contextIds, originSearchQuery}),
    // In the half-width panel, an open history dropdown would cover the new draft.
    {hideHistory: !expanded}
  );
  if (expanded) {
    SidepanelActions.expandSection(NavConstants.SECTIONS.AI);
  } else {
    SidepanelActions.openSectionAlongsidePage(NavConstants.SECTIONS.AI);
  }
}
